/*
TODO
*/
import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  formatDate: {
    fontSize: "0.7em",
    opacity: "0.8",
    margin: "4px 0 0 0",
  },
  // --- recup
  inputDate: {
    width: "162px !important",
  },
  select: {
    flex: "1",
    paddingRight: "20px !important",
    "&:last-child": {
      padding: "0 !important",
    },
    background: theme.color.white,
    "& .MuiInputLabel-shrink": {
      background: `${theme.color.gray1} !important`,
    },
  },
  datePicker: {
    width: "100%",
    maxWidth: 140,
  },
  disabled: {
    "& *": {
      color: `${theme.color.gray3} !important`,
    },
  },
  disabledButton: {
    backgroundColor: `${theme.color.gray3} !important`,
  },
  SwitchControl: {
    "& .MuiTypography-body1": {
      fontSize: "14px",
    },
  },
}));
